import { render } from "./PayrollProBusiness.vue?vue&type=template&id=12cc24b6&ts=true"
import script from "./PayrollProBusiness.vue?vue&type=script&lang=ts"
export * from "./PayrollProBusiness.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__